import React from 'react';

// wordpress components
import { useState } from '@wordpress/element';
import {
  __experimentalInputControl as InputControl,
  Button,
  Flex,
  FlexBlock,
} from '@wordpress/components';

// stripe components
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

// local components
import StepTitle from './elements/StepTitle';

const PaymentForm = (props) => {
  const [cardHolderName, setCardHolderName] = useState('');
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    // check if stripe elements did init
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // validate holder name
    // console.log('cardHolderName is ', cardHolderName);
    if (cardHolderName.length === 0) {
      props.notify({
        content: 'Card Holder Name cannot be empty.',
        status: 'error',
      });
      return;
    }

    // Get a reference to a mounted CardElement
    const cardElement = elements.getElement(CardElement);
    // console.log("cardElement:", cardElement._empty);

    // check if card details is empty
    if (cardElement._empty) {
      props.notify({
        content: 'Your card number is incomplete.',
        status: 'error',
      });
      return;
    }

    // if ADD card: create a payment method with Stripe(validate it also this way)
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    // show error in dashboard notifications
    if (error) {
      //console.log('Card error:', error);
      props.notify({
        content: 'Stripe create payment error: ' + error.message,
        status: 'error',
      });
      return;
    }
    // log the new created payment method
    else console.log('Stripe paymentMethod created:', paymentMethod);

    // UPDATE card: retrieve payment from stripe to update it
    // else {
    //   paymentMethod = aqwait stripe.retrive(props.card.paymentId);
    // }

    // create / update CUSTOMER
    // if adding card - create customer on stripe with this payment method as default
    // if(!props.hasCard) {}

    // add this new method to the customer and make it default
    // else {}

    // attach customer to this payment method
    paymentMethod.cardHolderName = cardHolderName;

    // add / update card in the database
    props.setCard(paymentMethod);
  };

  return (
    <Flex className='step-holder'>
      <StepTitle>Payment Information</StepTitle>

      <br />

      {/* Card Holder */}
      <Flex className='section-title'>Name on the card</Flex>
      <InputControl
        className='card-holder-name'
        placeholder='John Doe'
        value={cardHolderName}
        onChange={(nextVal) => setCardHolderName(nextVal)}
      />

      <br />

      {/* Card Number */}
      <Flex className='section-title'>Card number</Flex>
      <Flex style={{ margin: '0' }}>
        <CardElement options={{ hidePostalCode: true }} />
      </Flex>

      <FlexBlock />

      {/* Submit button */}
      <Flex className='step-footer'>
        <div>
          Safely encrypted and stored by our partner{' '}
          <a href='https://stripe.com/' target='_blank' rel='noreferrer'>
            Stripe
          </a>
        </div>

        <FlexBlock />

        <Button
          isPrimary
          disabled={!stripe}
          onClick={(event) => handleSubmit(event)}
        >
          {props.hasCard ? 'Update Card' : 'Add Card'}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PaymentForm;
